<div class="bg-white rounded-xl w-full p-6 mt-6 shadow-[3px_8px_8px_rgba(0,0,0,0.3)] animate-fade-in">
  <!--INFORMAÇÕES DO LOCAL-->
  <div class="grid grid-cols-6 gap-2 text-center items-center">
    <div class="bg-[#ECEDF2] p-1 rounded-md font-bold text-sigecom-info col-span-1">
      Data:
      <span class="text-sigecom-info font-medium text-base">
        {{ (gameTable?.embDtEmbate | date: "dd/MM/yyyy") || "Sem data" }}
      </span>
    </div>

    <div class="bg-[#ECEDF2] p-1 rounded-md font-bold text-sigecom-info col-span-4">
      Local:
      <span class="text-sigecom-info font-medium text-base">
        {{ gameTable?.areTxNome || "Local não informado" }}
      </span>
    </div>

    <div class="bg-[#ECEDF2] p-1 rounded-md font-bold text-sigecom-info col-span-1">
      <span class="text-sigecom-info font-medium text-base">
        {{ gameTable?.epcTxNome || "Espaço não informado" }}
      </span>
    </div>
  </div>
  <div class="bg-[#ECEDF2] text-center p-1 mt-2 rounded-md font-bold text-sigecom-info col-span-4">
    Endereço:
    <span class="text-sigecom-info font-medium text-base">
      {{ gameTable?.logTxLogradouro || "Endereço não informado" }}
    </span>
  </div>

  <!-- CABEÇALHO INFORMAÇÕES DOS PLACARES-->

  <div class="grid grid-cols-[repeat(20,minmax(0,1fr))] w-full mt-8 text-[#787878] gap-4">
    <div class="text-center col-span-1">
      <span class="">Mod.</span>
    </div>
    <div class="text-center col-span-1">
      <p>Hora</p>
    </div>
    <div class="text-center col-span-1">
      <p>Ch.</p>
    </div>
    <div class="text-center col-span-1">
      <p>Nº</p>
    </div>
    <p class="col-span-6">Equipe A</p>
    <p class="col-span-2 text-center">Placar</p>
    <p class="col-span-6">Equipe B</p>
    <div class="col-span-2">
      <p class="text-center">Detalhes</p>
    </div>
  </div>
  <!-- <div class="col-span-1">
        <span class="w-full flex justify-center items-center">Editar</span>
      </div>
     <div class="col-span-1">
        <span class="w-full flex justify-center items-center">Tabela</span>
      </div>
    <div class="col-span-1">
        <span class="w-full flex justify-center items-center">Apagar</span>
      </div> -->

  <!-- INFORMAÇÕES DOS PLACARES-->
  <div *ngFor="let info of gameTable?.embListEmbates; let i = index"
    class="grid grid-cols-[repeat(20,minmax(0,1fr))] w-full mt-3 gap-4">
    <div class="col-span-1 flex place-content-center">
      <span class="h-12 w-12 bg-[#ECEDF2] rounded-lg flex items-center justify-center">{{
        getModalidadeSigla(info)
        }}
      </span>
    </div>
    <div class="col-span-1 flex place-content-center">
      <span class="h-12 w-12 bg-[#ECEDF2] rounded-lg flex items-center justify-center">{{ info.embTmEmbate?.slice(0, 5)
        || "?" }}
      </span>
    </div>
    <div class="col-span-1 flex text-center place-content-center">
      <span class="h-12 w-12 bg-[#ECEDF2] rounded-lg flex items-center justify-center">{{
        info.chaveEmbateSimplesDto?.cheTxNome || "?" }}
      </span>
    </div>
    <div class="col-span-1 flex place-content-center">
      <span class="h-12 w-12 bg-[#ECEDF2] rounded-lg flex items-center justify-center">{{ info.embNrOrdemJogo }}
      </span>
    </div>
    <span class="w-full h-12 bg-[#ECEDF2] rounded-lg col-span-6 font-bold">
      <div class="pt-2 pl-3 pr-2 text-sm truncate">
        {{
        info.embListInscricoes.at(0)?.iemTxNome ||
        info.embListInscricoes.at(0)?.iemTxNomeDefault
        }}
      </div>
      <div class="text-xs pb-2 pl-3" *ngIf="info.embListInscricoes.at(0)?.estTxSigla">
        {{ info.embListInscricoes.at(0)?.estTxSigla }}
      </div>
    </span>

    <!-- PLACAR -->
    <div class="items-center justify-center flex col-span-2 py-1 gap-3 text-center text-sm">
      <div class="h-full aspect-square place-content-center rounded-lg border" [ngClass]="{
          'border-[#31920F] text-[#31920F]':
            getPontos(info, 0) > getPontos(info, 1),
          'border-[#FF3B30] text-[#FF3B30]':
            getPontos(info, 0) < getPontos(info, 1),
          'border-[#787878] text-[#787878]':
            getPontos(info, 0) === getPontos(info, 1),
        }">
        {{ getPontos(info, 0) }}
      </div>

      <p class="text-center text-xl font-semibold text-[#787878]">X</p>

      <div class="h-full aspect-square  place-content-center rounded-lg border" [ngClass]="{
              'border-[#31920F] text-[#31920F]':
                getPontos(info, 0) < getPontos(info, 1),
              'border-[#FF3B30] text-[#FF3B30]':
                getPontos(info, 0) > getPontos(info, 1),
              'border-[#787878] text-[#787878]':
                getPontos(info, 0) === getPontos(info, 1),
            }">
        {{ getPontos(info, 1) }}
      </div>
    </div>

    <!-- EQUIPE B -->
    <span class="w-full h-12 bg-[#ECEDF2] rounded-lg col-span-6 font-bold">
      <div class="pt-2 pl-3 pr-2 text-sm truncate">
        {{
        info.embListInscricoes.at(1)?.iemTxNome ||
        info.embListInscricoes.at(1)?.iemTxNomeDefault
        }}
      </div>
      <div class="text-xs pb-2 pl-3" *ngIf="info.embListInscricoes.at(1)?.estTxSigla">
        {{ info.embListInscricoes.at(1)?.estTxSigla }}
      </div>
    </span>

    <div class="col-span-1 flex place-content-center ">
      <span (click)="OpenModalScoreboard(info)"
        class="h-12 w-12 grid-cols-1 bg-[#ECEDF2] cursor-pointer rounded-lg flex items-center justify-center text-sigecom-info">
        <fa-icon icon="trophy"></fa-icon>
      </span>
    </div>
    <!-- <div class="col-span-1 w-full flex items-center justify-center">
        <span
          (click)="editParticipants(i)"
          class="h-12 w-12 cursor-pointer bg-[#ECEDF2] rounded-lg flex items-center justify-center text-sigecom-info"
        >
          <fa-icon [icon]="['fas', 'pen']"></fa-icon>
        </span>
      </div> -->
    <div class="col-span-1 flex place-content-center ">
      <p (click)="goToConfrontDetails(info)"
        class="h-12 w-12 cursor-pointer bg-[#ECEDF2] rounded-lg flex items-center justify-center text-sigecom-info">
        <fa-icon icon="external-link"></fa-icon>
      </p>
    </div>
    <!-- <div class="col-span-1 w-full flex items-center justify-center">
        <span
          (click)="goToClassificationTable(i)"
          class="h-12 w-12 cursor-pointer bg-[#ECEDF2] rounded-lg flex items-center justify-center text-sigecom-info"
        >
          <fa-icon [icon]="['fas', 'table']"></fa-icon>
        </span>
      </div> -->
    <!-- <div class="col-span-1 w-full flex items-center justify-center">
        <span
          (click)="deleteLine(i)"
          class="h-12 w-12 cursor-pointer bg-[#ecd6d6] rounded-lg flex items-center justify-center text-sigecom-danger"
        >
          <fa-icon icon="trash"></fa-icon>
        </span>
      </div> -->
  </div>
</div>

<!--MODAL DE PLACARES-->
<sigecom-modal [open]="modalPlacar" (modalStateChange)="closeModalScoreboard()">
  <sigecom-scoreboard (closeModalScoreboard)="closeModalScoreboard()" *ngIf="modalPlacar" [cheNrId]="cheNrId"
    [petNrId]="petNrId" [teams]="teams!"></sigecom-scoreboard>
</sigecom-modal>
